module.exports = "\n<top-menu></top-menu>\n\n\n<main>\n    <div class=\"container\">\n        <router-outlet></router-outlet>\n    </div>\n</main>\n\n\n\n\n\n"